import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import GameGlassTextLogo from '~editor/components/GameGlassTextLogo'

export const GameGlass = () => {
  return (
    <Box
      w="33px"
      h="38.35px"
      backgroundImage="url('./logo_mark_bordered.png')"
      backgroundPosition="center center"
      backgroundSize="contain"
      backgroundRepeat="no-repeat"
      marginRight="5.19px"
    />
  )
}

const ForgeText = () => {
  return (
    <svg width="52" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.4966 2.2331C7.1867 1.3708 6.4307.4398 5.3262.4398h-.6785c-.6807 0-1.3141.1707-1.8947.512-.5646.3253-1.0173.7792-1.3567 1.3561l-.0013.0024c-.326.5663-.4878 1.1917-.4878 1.87v13.7111c0 .5018.4068.9086.9086.9086.307 0 1.7345-1.4263 1.7345-1.7346v-7.0591c0-.5523.4478-1 1-1h1.3954c.1418 0 .285-.0449.3974-.1572.0987-.0988.1572-.2275.1572-.3738v-.9941c0-.5523-.4478-1-1-1H3.8925c-.1726 0-.3422-.1264-.3422-.299V4.0858c0-.3185.1051-.5728.3148-.7825.2098-.2098.464-.3148.7826-.3148h.649c.4385 0 .8576-.3278 1.1998-.7554z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4123 18.4741l.0045.0027.0045.0025c.5801.3242 1.212.4859 1.8903.4859h3.1151c.6782 0 1.3037-.1617 1.8699-.4877l.0024-.0014c.576-.3389 1.0365-.7902 1.3771-1.3521l.0019-.0034c.3417-.5809.5127-1.2148.5127-1.8959v-5.239c0-.6663-.1714-1.285-.5136-1.8504-.3397-.5768-.7996-1.0368-1.3764-1.3764-.5666-.343-1.1935-.5137-1.874-.5137h-3.1151c-.6807 0-1.3142.1707-1.8948.512-.5645.3253-1.0173.7793-1.3566 1.3562l-.0017.0028-.0016.0028c-.3235.579-.4858 1.2028-.4858 1.8667v5.239c0 .6783.1616 1.3101.4858 1.8903l.0026.0045.0027.0044c.3393.5599.7903 1.0109 1.3501 1.3502zm1.1167-9.3418l.003-.003.0028-.003c.2112-.2236.4637-.3324.7768-.3324h3.1151c.313 0 .5656.1088.7767.3323l.0058.0062.0061.0058c.2263.2137.3323.4595.3323.753v5.4279c0 .3135-.1094.5772-.3384.8062-.2097.2097-.464.3148-.7825.3148h-3.1151c-.3171 0-.5705-.1041-.7797-.3119-.2132-.2271-.3177-.4917-.3177-.8091V9.8913c0-.2992.1025-.5468.3148-.759z"
        fill="#fff"
      />
      <path
        d="M26.333 8.2107c.69-.8625-.0831-1.8003-1.1876-1.8003h-1.0325c-.3876 0-.7481.0796-1.0759.2435a4.7241 4.7241 0 00-.0174.0088c-.1203.0612-.2783.0003-.3737-.0951-.1123-.1123-.2555-.1572-.3974-.1572H21.16c-.5523 0-1 .4477-1 1v10.835c0 .1413.054.2648.1298.3658a.2945.2945 0 00.059.059c.101.0758.2245.1298.3658.1298h1.0885c.5523 0 1-.4477 1-1V9.7424c.0268-.2278.116-.4114.2676-.563.1441-.144.3262-.2203.5702-.2203h1.4749c.456 0 .8777-.324 1.2172-.7484z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7796 24.5582c.6657 0 1.2905-.1711 1.8694-.511.5797-.3246 1.0342-.7788 1.359-1.3582.3419-.5659.512-1.1919.512-1.8713V7.4369c0-.2862-.1125-.5341-.3221-.728-.1939-.2096-.4418-.3221-.728-.3221h-5.6167c-1.1451 0-2.0783.3339-2.7599 1.033l-.0026.0028c-.6566.691-.9779 1.5693-.9779 2.6103v5.0266c0 1.0512.302 1.9483.9206 2.6699l.0024.0029.0025.0028c.6498.72 1.5551 1.0649 2.6734 1.0649h2.8319c.4031 0 .7801-.1109 1.1251-.3288l.0032-.0021c.086-.0559.205.0038.205.1064v2.3366c0 .3131-.1088.5656-.3323.7767l-.0031.0029-.003.003c-.2122.2123-.4597.3148-.7589.3148h-2.9865c-.5412 0-1.0982.4157-1.5975.9301-.5857.6034-.074 1.6186.7669 1.6186h3.8171zm-3.0207-8.3069c-.3817 0-.6152-.1014-.7577-.2543-.1462-.1567-.2453-.4195-.2453-.8431v-5.121c0-.4187.1044-.6785.2617-.8357.1572-.1572.417-.2617.8356-.2617h3.0237c.5523 0 1 .4477 1 1v5.3989c-.0131.2197-.0985.4192-.2712.6057a1.0914 1.0914 0 01-.5324.2951.7211.7211 0 01-.1633.0161h-3.1511zM42.2911 18.3089l.0044.0027.0046.0025c.5801.3242 1.2119.4859 1.8902.4859h5.4072c.5523 0 1-.4477 1-1v-.9941c0-.1419-.0449-.2851-.1572-.3974-.1123-.1123-.2555-.1572-.3974-.1572h-5.8526c-.3185 0-.5728-.1051-.7826-.3148-.2097-.2097-.3147-.464-.3147-.7826v-.8419c0-.3009.3244-.5151.6253-.5151h6.4662c.2816 0 .5838-.0682.7458-.3274.1205-.1928.1628-.4376.1628-.6991v-2.7139c0-1.1192-.3534-2.0242-1.0883-2.6732-.7062-.6532-1.5982-.973-2.6522-.973h-3.1623c-1.0553 0-1.9543.3204-2.6755.9728-.7201.6498-1.065 1.555-1.065 2.6734v5.003c0 .6783.1617 1.3101.4859 1.8903l.0025.0045.0027.0044c.3393.5599.7903 1.0109 1.3502 1.3502zm.8019-8.276c0-.3998.1082-.6562.2812-.8202.2052-.1796.4696-.2772.8161-.2772h3.2331c.4095 0 .6627.1038.8162.2599.1544.157.2576.4176.2576.8375v.2389c0 .5523-.4477 1-1 1H44.093c-.5523 0-1-.4477-1-1v-.2389z"
        fill="#fff"
      />
    </svg>
  )
}

interface LogoProps {
  forge?: boolean
  width?: string
  height?: string
}

const Logo: React.FC<LogoProps> = () => {
  return (
    <Flex flexDirection="row" justifyContent="center" alignItems="center">
      <GameGlass />
      <Flex
        width="102px"
        height="22px"
        justifyContent="center"
        alignItems="center"
      >
        <GameGlassTextLogo />
      </Flex>
    </Flex>
  )
}

export default Logo
